import { Brand } from "@marekl/adminer/components";
import { isTestInstance } from "../../lib/environment";
import styles from "./BrandLockup.module.css";

interface BrandLockupProps {
  /** Compact mode: smaller logo, single-line. Used in sidebar. */
  compact?: boolean;
  className?: string;
}

export function BrandLockup({ compact, className }: BrandLockupProps) {
  const cls = [styles.lockup, compact ? styles.compact : styles.full, className]
    .filter(Boolean)
    .join(" ");

  const brand = (
    <Brand
      namePrefix="ČNSMS"
      nameSuffix="IS"
      tagline={compact ? "" : "Informační systém"}
    />
  );
  // On a test instance the rail says so beside the name, on every page after
  // the banner above has scrolled away.
  const env = isTestInstance && <span className={styles.env}>Test</span>;

  return (
    <div className={cls}>
      <img
        src="/logo.webp"
        alt="ČNSMS, Český národní svaz mažoretkového sportu"
        className={styles.logo}
      />
      {compact ? (
        // One baseline group, so the badge is placed against the name's
        // letters rather than the taller box the lib's Brand draws round them.
        <div className={styles.wordmark}>
          {brand}
          {env}
        </div>
      ) : (
        <>
          {brand}
          {env}
        </>
      )}
    </div>
  );
}
